
import { ImageField, ImageInput, useInput } from "react-admin";
import { Remove } from '@material-ui/icons';
import React from "react";
import { validateRequired } from "../../utils/Validations";

const Pictures = ({ handleImageChange, classes }) => {
  const { input: picturesInput } = useInput({ source: "pictures" });

  const handleDeletePicture = (idx) => {
    const currentPictures = picturesInput.value || [];
    const updated = currentPictures.filter((_, i) => i !== idx);
    picturesInput.onChange(updated);
  };

  const handleImageDrop = (acceptedFiles, rejectedFiles, event) => {
    handleImageChange?.(acceptedFiles);
    const currentFiles = picturesInput.value || [];
    if (currentFiles.length + acceptedFiles.length > 3) {
      alert("You can only upload up to 3 images.");
      picturesInput.onChange([...currentFiles]);
    } else {
      picturesInput.onChange([...currentFiles, ...acceptedFiles]);
    }
  }

  const getImageSrc = (item) => {
    if (typeof item === 'string') return item;
    if (item?.src) return item.src;
    if (item instanceof File) return URL.createObjectURL(item); // ✅ safe
    return null;
  };

  return (
    <>
      {/* Inline style for hover effect */}
      <style>
        {`
          .picture-wrapper {
            position: relative;
            display: inline-block;
          }
          .remove-btn {
            display: none;
            position: absolute;
            top: 2px;
            right: 2px;
            background: rgba(255,255,255,0.7);
            border: none;
            border-radius: 50%;
            cursor: pointer;
            padding: 2px;
          }
          .picture-wrapper:hover .remove-btn {
            display: block;
            color: red;
          }
        `}
      </style>
      <ImageInput
        source="pictures"
        label="Upload Rings"
        accept="image/png"
        maxSize={1500000}
        validate={validateRequired}
        options={{
          onDrop: handleImageDrop,
          multiple: true,
          maxFiles: 2
        }}
        multiple={true}
        placeholder={
          <p>
            Upload Ring Image
            <span className={classes.warnLabel}>
              *File size should not exceed 1.5MB and file format must be png
            </span>
          </p>
        }
      >
        <ImageField source="src" title="images" style={{display: 'none'}} />
      </ImageInput>
      {Array.isArray(picturesInput.value) && picturesInput.value.length > 0 && (
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          {picturesInput.value.map((pic, idx) => (
            <div key={idx} className="picture-wrapper">
              <img
                src={getImageSrc(pic)}
                height={180}
                alt={`static ring ${idx + 1}`}
                style={{ borderRadius: 4, objectFit: 'cover' }}
              />
              <button
                type="button"
                className="remove-btn"
                onClick={() => handleDeletePicture(idx)}
                title="Delete"
              >
                <Remove />
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default Pictures;